<!-- app.component.html -->
<!-- <mat-toolbar color="primary">
  <span>iseven</span>
</mat-toolbar> -->

<main class="app-content">
  <router-outlet></router-outlet>
</main>
